import { Text, TextStyle } from "pixi.js";
import { MyWalletResourcePackage } from "../../../resources/MyWalletResourcePackage";
import { GameFont } from "by/gamefactory/cityversetycoon/scenes/common/GameFont";
import { WalletTabType } from "../../WalletTabType";
import { NFTScrollItem } from "./NFTScrollItem";

export class ScrollNextElement extends NFTScrollItem {
    private readonly innerText: Text;

    public constructor(myWalletResources: MyWalletResourcePackage, type: WalletTabType) {
        super(myWalletResources.assets_views_my_wallet_ui_scroll_glass_png, null);
        this.innerText = new Text(`YOUR NEXT\n${this.getNextElementNameByType(type)}\nWILL BE HERE`, new InnerTextStyle());
        this.addChild(this.innerText);
        this.innerText.position.set((this.width - this.innerText.width) * 0.5, (this.height - this.innerText.height) * 0.5);
    }

    public getNextElementNameByType(type: WalletTabType): string {
        switch (type) {
            case WalletTabType.BUILDING: return 'BUILDING';
            case WalletTabType.DICE_ROLLS: return 'DICE ROLLS';
            case WalletTabType.PIGGY_CLUB: return 'PIGGY CLUB';
            default: return 'NFT';
        }
    }
}

class InnerTextStyle extends TextStyle {
    public constructor() {
        super({
            fontFamily: GameFont.DEFAULT_FONT,
            fontSize: 40,
            fill: 'FFFFFF',
            align: 'center',
            lineHeight: 43
        });
    }
}
